import {
  FETCH_OT_NONALLOCATED_LOC_REQUEST,
  FETCH_OT_NONALLOCATED_LOC_SUCCESS,
  FETCH_OT_NONALLOCATED_LOC_FAILURE,
} from "../constants/OTNonAllocatedLocConstants";

import OTNonAllocatedLocService from "../service/OTNonAllocatedLocService";

export const fetchOTNonAllocatedLoc = (date) => async (dispatch) => {
  if (!date) {
    console.error("Date is required");
    return;
  }

  try {
    dispatch({ type: FETCH_OT_NONALLOCATED_LOC_REQUEST });

    const data = await OTNonAllocatedLocService.getAll(date);

    dispatch({
      type: FETCH_OT_NONALLOCATED_LOC_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_OT_NONALLOCATED_LOC_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};
